import { render } from "./Landing.vue?vue&type=template&id=ef174e58"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
script.render = render

export default script